<template>
    <div v-if="type!='button'"
        class="fav-element"
        @click.prevent="toggleFav"
        @keydown.enter.prevent="toggleFav"
        @keydown.space.prevent="toggleFav"
        tabindex="0"
        :aria-label="ariaLabel"
        :title="title">

        <i class="fa"
            aria-hidden="true"
            :class="{'fa-heart':isFav(),'fa-heart-o':!isFav()}"></i>

    </div>

    <button v-else
        type="button"
        @click="toggleFav"
        @keydown.enter.prevent="toggleFav"
        @keydown.space.prevent="toggleFav">
        <i class="fa"
            aria-hidden="true"
            :class="{'fa-heart':isFav(),'fa-heart-o':!isFav()}"></i>

        <span v-show="!isFav()">{{addLabel}}</span>
        <span v-show="isFav()">{{removeLabel}}</span>

    </button>

</template>

<script>
    import V from 'voUtils/V.js'

    import {
    	isFav, toggleFav, onFavUpdate, getFavIds
    }
    from 'voUtils/FavStore.js';


    export default {
    	voVueComponent: 'voffice-fav-element',

    	data() {
    		return {
    			isFavorite: false
    		};
    	},
    	props: {
    		type: String,
    		unitId: Number,
    		addLabel: String,
    		removeLabel: String
    	},
    	computed: {
    		title: function() {
    			return this.voMsg('favorites');
    		},

    		ariaLabel: function() {
    			return this.isFavorite ? this.removeLabel || this.voMsg('tpl.text.removeFavLabel') : this.addLabel || this.voMsg('tpl.text.addFavLabel');
    		}

    	},
    	mounted: function() {
    		onFavUpdate(() => {
    			this.isFavorite = isFav(this.unitId);
    			this.$forceUpdate();
    		});

    		this.isFavorite = isFav(this.unitId);

    	},
    	methods: {
    		isFav: function() {
    			return isFav(this.unitId);
    		},
    		toggleFav: function() {
    			V.log("Fav clicked!", this.unitId);
    			toggleFav(this.unitId);
    			this.isFavorite = isFav(this.unitId);
    		}
    	}


    };
</script>